import PrintTags from "./components/printTags/PrintTags";
import OpenPull from "./components/openPulls/OpenPull";
import EcomOrders from "./components/ecomOrders/EcomOrders";
import FramePick from "./components/framePick/FramePick";
import SpecialOrderQueue from "./components/framePick/SpecialOrderQueue/SpecialOrderQueue";
import Vendor from "./components/vendor/Vendor";
import DailyOrders from "./components/orderStatus/DailyOrders";
import OrderStatus from "./components/orderStatus/OrderStatus";
import AccessoryReplenishment from "./components/systemPreference/AccessoryReplenishment";
import KitMaintenance from "./components/kits/kitMaintenance/KitMaintenance";
import NewStyleKit from "./components/kits/kitMaintenance/NewStyleKit";
import FrameArrangerQty from "./components/FrameArranger/FrameArrangerQty/FrameArrangerQty";
import styles from "./components/navbar/navbarMenu.module.scss";
import VendorsAndCollection from "./components/FrameArranger/VendorsAndCollections/VendorsAndCollection";
import ProductPlanogram from "./components/FrameArranger/ProductPlanogram/ProductPlanogram";
import OfficeCollectionMapping from "./components/FrameArranger/OfficeCollection/OfficeCollectionMapping";
import { reactApp } from "./util/constants/common.constants";
import ValidateAcuityFrameImport from "./components/FrameArranger/ValidateAcuityFrameImport/ValidateAcuityFrameImport";
import KitProcessing from "./components/kits/KitProcessing/KitProcessing";
import ProcessNewKit from "./components/kits/KitProcessing/ProcessNewKit";
import KitDetailPage from "./components/kits/kitMaintenance/KitDetailPage";
import FedEx from "./components/FedEx/Fedex/FedEx";
import ExpressOffices from "./components/FedEx/ExpressOffices/ExpressOffices";
import Dashboard from "./components/Dashboard/Dashboard";
import Unauthorized from "./components/unauthorized/unauthorized";
import BulkCostUpdate from "./components/bulkCostUpdate/BulkCostUpdate";
import OfficeReplenishmentPO from "./components/officeReplenishmentPO/officeReplenishmentPO";
import { LocationListUpdate } from "./components/inventotyAudit/LocationList/LocationListUpdate";
import { InventoryUpdate } from "./components/inventotyAudit/InventoryUpdate/InventoryUpdate";
import { ReplenishmentJobUpdate } from "./components/ReplenishmentJobUpdate/ReplenishmentJobUpdate";
import  UndoInventoryPost  from "./components/inventotyAudit/UndoInventoryPost/UndoInventoryPost";
import MoveToFtpFolder from "./components/FtpFileTransfer/MoveToFtpFolder";
import UploadToFtpFolder from "./components/FtpFileTransfer/UploadToFtpFolder";
import FeatureManagement from "./components/featureManagement/FeatureManagement";
import PermissionManagement from "./components/featureManagement/PermissionManagement";
import { FEATURE_NAMES } from "./util/constants/feature.constants";



const routes = [
    {
        path: "/dashboard",
        title: "Dashboard",
        content: () => <Dashboard />,
    },
    {
        title: "Frame Pick",
        children: [
            {
                path: "/framePickQueue",
                title: "Frame Pick Queue",
                featureName: FEATURE_NAMES.FramePickQueue,
                content: () => <FramePick />,
            },
            {
                path: "/specialOrderQueue",
                title: "Special Order Queue",
                featureName: FEATURE_NAMES.SpecialOrderQueue,
                content: () => <SpecialOrderQueue />,
            },
        ],
    },
    {
        title: "Replenishment",
        children: [
           {
               path: "/officereplenishmentpo",
               title: "Office",
                featureName: FEATURE_NAMES.OfficeReplenishmentPO,
                content: () => <OfficeReplenishmentPO />,
            },
            {
                path: "/replenishmentPreferences",
                title: "Accessories",
                featureName: FEATURE_NAMES.ReplenishmentPreferences,
                content: () => <AccessoryReplenishment />,
            },
        ],
    },
    {
        title: "Frame Arranger",
        children: [
            {
                path: "/vendorsCollectionsMapping",
                title: "Vendors to Collections Mapping",
                featureName: FEATURE_NAMES.VendorsToCollectionsMapping,
                content: () => <VendorsAndCollection />,
            },
            {
                path: "/assortmentManagement",
                title: "Assortment Management",
                featureName: FEATURE_NAMES.AssortmentManagement,
                content: () => <FrameArrangerQty />,
            },
            {
                path: "/officeCollectionsMapping",
                title: "Office Planograms",
                featureName: FEATURE_NAMES.OfficePlanograms,
                content: () => <OfficeCollectionMapping />,
            },
            {
                path: "/productPlanogram",
                title: "Product Planogram",
                featureName: FEATURE_NAMES.ProductPlanogram,
                content: () => <ProductPlanogram />,
            },
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FRAME_ItemImportIntoAcuity",
                title: "Planogram Export",
                featureName: FEATURE_NAMES.PlanogramExport,
            },
            {
                path: "/ValidateAcuityFrameImport",
                title: "Validate Acuity Frame Import",
                featureName: FEATURE_NAMES.ValidateAcuityFrameImport,
                content: () => <ValidateAcuityFrameImport />,
            },
        ],
    },
    {
        title: "New Style Kits",
        children: [
            {
                path: "/kitMaintenance",
                title: "Kit Maintenance",
                featureName: FEATURE_NAMES.KitMaintenance,
                content: () => <KitMaintenance />,
            },
            {
                path: "/KitProcessing",
                title: "Kit Processing",
                featureName: FEATURE_NAMES.KitProcessing,
                content: () => <KitProcessing />,
            },
        ],
    },
    {
        path: "/newKit",
        title: "",
        content: () => <NewStyleKit />,
    },
    {
        path: "/processNewKit",
        title: "",
        content: () => <ProcessNewKit />,
    },
    {
        path: "/kitDetailPage",
        title: "",
        content: () => <KitDetailPage />,
    },
    {
        title: "Reports",
        featureName: FEATURE_NAMES.Reports,
        children: [
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FrameArrangerLocationInventoryTransfers",
                title: "Frame Arranger - Location Inventory Transfers",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FrameArrangerLocationOnHandInventory",
                title: "Frame Arranger - Location On Hand Inventory",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "FrameArranger/FrameArrangerLocationVendorCollection",
                title: "Frame Arranger - Location Vendor Collection",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "Replenishment Reports/ReplenishmentStockTransfer",
                title: "Frame Arranger - Replenishment Stock Transfer",
            },
            {
                path:
                    reactApp().reportDomainName +
                    "Replenishment Reports/ReplenishmentVendorOrder",
                title: "Frame Arranger - Replenishment Vendor Order",
            },
            {
                path:
                    reactApp().reportDomainName + "FreezeFramePickQueue",
                title: "Canceled Frame Pick Orders",
            },
            {
                path:
                    reactApp().reportDomainName + "30-Day%20Turn%20Time",
                title: "30 Day Turn Around Time",
            },
            {
                path:
                    reactApp().reportDomainName + "InvalidOfficeTransfers",
                title: "Invalid Transfers",
            },
            {
                path:
                    reactApp().reportDomainName + "ArrangerPlanogramCompare",
                title: "Arranger Planogram Compare",
            },
            {
                path:
                    reactApp().reportDomainName + "Location%20On%20Hand%20Inventory",
                title: "Location On Hand Inventory",
            },
            {
                path:
                    reactApp().reportDomainName + "Transfers_All_Detail",
                title: "Transfers All Detail",
            },
            {
                path:
                    reactApp().reportDomainName + "Vendor%20Receipt",
                title: "Vendor Receipt",
            },
        ],
    },
    {
        title: "Utilities",
        children: [
            {
                path: "/expressOffices",
                title: "FedEx Express Offices",
                featureName: FEATURE_NAMES.ExpressOffices,
                content: () => <ExpressOffices />,
            },
            {
                path: "/fedex",
                title: "FedEx Shipping Labels",
                featureName: FEATURE_NAMES.FedEx,
                content: () => <FedEx />,
            },
            {
                path: "/openPull",
                title: "Open Pull",
                featureName: FEATURE_NAMES.OpenPull,
                content: () => <OpenPull />,
            },
            {
                path: "/ecomOrders",
                title: "Ecom Orders",
                featureName: FEATURE_NAMES.EcomOrders,
                content: () => <EcomOrders />,
            },
            {
                path: "/printTags",
                title: "Print Little Tags",
                featureName: FEATURE_NAMES.PrintTags,
                content: () => <PrintTags />,
            },
            {
                path: "/orders",
                title: "View Orders",
                featureName: FEATURE_NAMES.ViewOrders,
                content: () => <OrderStatus />,
            },
            {
                path: "/vendor",
                title: "Vendor Assignment",
                featureName: FEATURE_NAMES.VendorAssignment,
                content: () => <Vendor />,
            },
            {
                path: "/orderSearch",
                title: "Update Order Status",
                featureName: FEATURE_NAMES.UpdateOrderStatus,
                content: () => <DailyOrders />,
            },
            {
                path: "/bulkCostUpdate",
                title: "Bulk Cost Update",
                featureName: FEATURE_NAMES.BulkCostUpdate,
                content: () => <BulkCostUpdate />,
            },
            {
                path: "/replenishmentJobConfiguration",
                title: "Replenishment Job Configuration",
                featureName: FEATURE_NAMES.ReplenishmentJobConfiguration,
                content: () => <ReplenishmentJobUpdate />,
            }
        ],
    },
    {
        title: "Quarterly DC Audit",
        children: [
            {
                path: "/locationList",
                title: "Location List Update",
                featureName: FEATURE_NAMES.LocationListUpdate,
                content: () => <LocationListUpdate />,
            },
            {
                path: "/finalInventoryUpdate",
                title: "Final Inventory Update",
                featureName: FEATURE_NAMES.FinalInventoryUpdate,
                content: () => <InventoryUpdate />,
            },
            {
                path: "/undoInventoryPost",
                title: "Undo Inventory Post",
                featureName: FEATURE_NAMES.UndoInventoryPost,
                content: () => <UndoInventoryPost />,
            }
        ],
    },
    {
        title: "Settings",
        adminOnly: true,
        children: [
            {
                path: "/featureManagement",
                title: "Feature Management",
                content: () => <FeatureManagement />,
            },
            {
                path: "/permissionManagement",
                title: "Permission Management",
                content: () => <PermissionManagement />,
            },
        ],
    },
    {
        path: "/unauthorized",
        title: "",
        content: () => <Unauthorized />,
    },
    {
        path: "/moveToProcessPO",
        title: "Move To Process PO",
        content: () => <MoveToFtpFolder />,
    },
    {
        path: "/uploadToVendorPO",
        title: "Upload File To Vendor PO",
        content: () => <UploadToFtpFolder />,
    },
];

export default routes;
